import { combineClassNames } from '@arkestro/arkestro-design-system';
import {
  COLLAPSED_LOGO_WHITE_URL,
  FULL_LOGO_BLACK_URL,
  FULL_LOGO_WHITE_URL,
} from '@utils/constants';

import styles from './logo.module.scss';

interface ArkestroLogoProps {
  collapsed?: boolean;
  dark?: boolean;
  style?: React.CSSProperties;
}

export const ArkestroLogo = ({ collapsed, dark, style }: ArkestroLogoProps) => {
  const getLogoUrl = () => {
    if (collapsed) return COLLAPSED_LOGO_WHITE_URL;
    if (dark) return FULL_LOGO_BLACK_URL;
    return FULL_LOGO_WHITE_URL;
  };
  const logoImage = getLogoUrl();
  const logoWidth = collapsed ? 38 : 150;

  const wrapperClassName = combineClassNames(
    styles.arkestroLogo,
    collapsed && styles.collapsed,
  );

  return (
    <div className={wrapperClassName} data-testid="arkestro-logo" style={style}>
      <img
        alt='Arkestro'
        className={styles.arkestroLogoImage}
        height={38}
        src={logoImage}
        translate="no"
        width={logoWidth}
      />
    </div>
  );
};
